import { render, staticRenderFns } from "./underline.vue?vue&type=template&id=38123189&scoped=true&"
import script from "./underline.vue?vue&type=script&lang=js&"
export * from "./underline.vue?vue&type=script&lang=js&"
import style0 from "./underline.vue?vue&type=style&index=0&id=38123189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38123189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
